import { combineReducers } from 'redux';
import { queryClient } from '~/main';
import alertsReducer from './alertsReducer';
import authReducer from './authReducer';
import dsoReducer from './dsoReducer';
import errorReducer from './errorReducer';
import feedbackReducer from './feedbackReducer';
import jobReducer from './jobReducer';
import loadingReducer from './loadingReducer';
import messageReducer from './messageReducer';
import messagesReducer from './messagesReducer';
import multidayReducer from './multidayReducer';
import officeReviewReducer from './officeReviewReducer';
import ppReducer from './ppReducer';
import receiptReducer from './receiptReducer/receiptReducer';
import successReducer from './successReducer';
import userCredentialsReducer from './userCredentialsReducer';
import userReducer from './userReducer';
import PermanentJobsReducer from './permanentJobsReducer';

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  userCredentials: userCredentialsReducer,
  error: errorReducer,
  success: successReducer,
  loading: loadingReducer,
  feedback: feedbackReducer,
  job: jobReducer,
  message: messageReducer,
  alerts: alertsReducer,
  multiday: multidayReducer,
  messages: messagesReducer,
  pp: ppReducer,
  officeRating: officeReviewReducer,
  receipt: receiptReducer,
  dso: dsoReducer,
  permanentJobs: PermanentJobsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_ACTION_SUCCESS') {
    localStorage.removeItem('refresh_token_dental');
    localStorage.removeItem('selectedOfficeId');
    queryClient.clear();

    state = {
      message: {
        message: {
          ...action.payload,
        },
      },
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
